
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSequenceConnector as ObcSequenceConnectorElement} from '@oicl/openbridge-webcomponents/dist/components/sequence-connector/sequence-connector.js';
 
 
 

 
 export const ObcSequenceConnector = createComponent({
   react: React,
   tagName: 'obc-sequence-connector',
   elementClass: ObcSequenceConnectorElement,
   events: {
     
   }
  });
 
 